import { Observable } from 'rxjs';
import { split, ref, getValues } from '@dbk-legacy/muster/utils';
import muster from '@dbk-legacy/muster';
import { sortable, variable, redirectOn } from '@dbk-legacy/muster/helpers';
import map from 'lodash/fp/map';
import { TRANSACTION_API_ERROR_CODES, VASCO_API_RESPONSE, TRANSACTION_TITLE  } from '../../constants';


export default () =>
  muster()
    .path('transactions.initializeTx', {
      call: async ({ req }, { get, set, call }) => {
        await set('transactions.initializeTxResponse', '');
        let txType = req.args[0];

        const [oReturn] = await getValues(get(`roster.data.transactions.initializeTx.["${txType}"]`));
        if (oReturn.$type && oReturn.$type.toLowerCase() == VASCO_API_RESPONSE.error) {
          return;
        } 
        const oResult = JSON.parse(oReturn);
        if (oResult.returnCode === TRANSACTION_API_ERROR_CODES.errorCode) {
          return;
        }
        await set('transactions.initializeTxResponse', oResult);
      }
    })
    .path('transactions.initializeTxResponse', variable(''))
    .path('transactions.generateTxChallenge', {
      call: async ({ req }, { get, set, call }) => {
        await set('transactions.generateTxChallengeResponse', '');
        let dataFields = encode(JSON.stringify(req.args[0]));
        let transactionTitle = req.args[1];
        let remarks = req.args[2];
        let sessionKey = req.args[3];
        let channel = req.args[4];
        let [txType] = await getValues(get('transactions.txType'));

        const [oReturn] = await getValues(get(`roster.data.transactions.generateTxChallenge.["${dataFields}"].["${transactionTitle}"].["${remarks}"].["${sessionKey}"].["${channel}"].["${txType}"]`));
        if (oReturn.$type && oReturn.$type.toLowerCase() == VASCO_API_RESPONSE.error) {
          return;
        } 
        const oResult = JSON.parse(oReturn);
        if (oResult.returnCode === TRANSACTION_API_ERROR_CODES.errorCode) {
          return;
        }
        await set('transactions.generateTxChallengeResponse', oResult);
      }
    })
    .path('transactions.generateTxChallengeResponse', variable(''))
    .path('transactions.verifyChallengeResponse', {
      call: async ({ req }, { get, set, call }) => {
        await set('transactions.verifyChallengeResponseValue', '');
        let txType = await getValues(get('transactions.txType'));
        let tdsSingnature = 'T' +req.args[1];
        let requestKey ='T'+ req.args[2];

        const [oReturn] = await getValues(get(`roster.data.transactions.verifyChallengeResponse.["${txType}"].["${tdsSingnature}"].["${requestKey}"]`));
        if (oReturn.$type && oReturn.$type.toLowerCase() === VASCO_API_RESPONSE.error) {
          return;
        }
        const oResult = JSON.parse(oReturn);
        if (oResult.returnCode === TRANSACTION_API_ERROR_CODES.errorCode) {
          return;
        }
        await set('transactions.verifyChallengeResponseValue', oResult);
      }
    })
    .path('transactions.setTxType', {
      call: async ({ req }, { get, set, call }) => {
        if (req.args[0]) {
          await set('transactions.txType', req.args[0]);
        }
      },
    })
    .path('transactions.verifyChallengeResponseValue', variable(''))
    .path('transactions.txType', variable(''))

  ;
